module.exports = __webpack_public_path__ + "static/media/price_compare.3f1f1350.svg";